import { useTranslation } from "react-i18next"
import OvertimeRow from "./OvertimeRow"
import PaginationBar from "components/widget/PaginationBar"


export default function OvertimesTable({
    title,
    icon = "fa-solid fa-file-arrow-up",
    items = [],
    isLoadingContent = false,
    onPageChange,
    currentPage,
    itemsPerPage,
    totalItems
}) {

    const [t, i18n] = useTranslation(["global", "absenceReport"])

    return (

        <div className={`card bg-black bg-opacity-10 text-white mb-4 ${isLoadingContent ? "opacity-25" : ""}`} id="absence-request">
            <div className="card-header">
                <i className={`${icon}`}></i> {title ? title : t("absenceReport:menu.requests")}
            </div>

            <div className="card-body text-center">

                {
                    items.length == 0 ?
                        <div className="text-center opacity-50 p-4"><h3><i className="fa-regular fa-folder-open fa-beat"></i> {t("absenceReport:no_data.no_requests")}</h3></div>
                        :
                        <>
                            <div className="row opacity-50">
                                {
                                    items[0].user != null &&
                                    <div className="col-sm">

                                    </div>
                                }

                                <div className="col-sm">
                                    {t("property.duration")}
                                </div>
                                <div className="col-sm">
                                    {t("property.period")}
                                </div>
                                {
                                    items.length > 0 && items[0].userDisplayName &&
                                    <div className="col-sm">
                                        {t("entity.employee")}
                                    </div>
                                }

                                <div className="col-sm">
                                    {t("property.notes")}
                                </div>
                                <div className="col-sm">
                                    {t("property.submited")}
                                </div>
                                {
                                    items[0].user != null &&
                                    <div className="col-sm">
                                        {t("property.actions")}
                                    </div>
                                }
                                <br />
                            </div>

                            <div className="container">
                                {items.map(overtime => (
                                    <OvertimeRow key={overtime.guid} overtime={overtime} />
                                ))}
                            </div>
                        </>
                }
            </div>

            <PaginationBar
                currentPage={currentPage}
                postsPerPage={itemsPerPage}
                totalPosts={totalItems}
                paginate={(e) => {
                    console.log(e)
                    onPageChange(e)
                }}
            />
        </div>
    )

}